/* eslint-disable react/no-children-prop */
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { MemberInfo, getDetails, getMembers } from './team';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useWindowSize } from 'react-use';

export const TeamDetails = (member: MemberInfo) => {
    const { id, name, image, bio, alt_lng, alt_cls } = member;
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [activeOption, setActiveOption] = useState<string>('English');
    const hasAlt = alt_lng !== undefined;
    const isEnglish = activeOption === 'English';
    const detailsToUse = isEnglish || !hasAlt ? id : id + '_alt';
    const DescClass = isEnglish ? 'teammember-description' : 'teammember-description ' + alt_cls;

    const { width } = useWindowSize();
    const isMobile = width <= 768;

    const toggle = () => setDropdownOpen(prevState => !prevState);

    const handleSwitchClick = (option: string) => {
        setActiveOption(option);
    };

    const members = getMembers();

    return (
        <>
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center">
                        <h2>Team Member Details</h2>
                        <ol>
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>Team Member Details</li>
                        </ol>
                    </div>
                </div>
            </section>
            <section id="teammember-details" className="teammember-details">
                <div className="container">
                    <div className="teammember-details-wrapper">
                        <div className="teammember-details-container">
                            <div className="teammember-img">
                                {image && <img src={`../${image}`} className="img-fluid" alt="" />}
                            </div>
                            <div className="teammember-details-text">
                                <h2>{name}</h2>
                                {bio && <h4>{bio}</h4>}
                            </div>
                        </div>
                        <div>
                            {hasAlt && !isMobile && (
                                <div className="SwitchContainer">
                                    <div
                                        className={
                                            activeOption === 'English'
                                                ? 'SwitchToggleItem SwitchActive'
                                                : 'SwitchToggleItem'
                                        }
                                        onClick={() => handleSwitchClick('English')}
                                    >
                                        <div className={'SwitchText'}>English</div>
                                    </div>
                                    <div
                                        className={
                                            activeOption !== 'English'
                                                ? 'SwitchToggleItem SwitchActive'
                                                : 'SwitchToggleItem'
                                        }
                                        onClick={() => handleSwitchClick(alt_lng)}
                                    >
                                        <div className={'SwitchText'}>{alt_lng}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={DescClass}>
                        <ReactMarkdown children={getDetails(detailsToUse)} />
                    </div>

                    {!isMobile && (
                        <div className="d-flex justify-content-between">
                            <div />
                            <div>
                                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                    <DropdownToggle caret>Select Team Member</DropdownToggle>
                                    <DropdownMenu>
                                        {members.map(member => (
                                            <DropdownItem key={member.id} href={`/team/${member.id}`}>
                                                {member.name}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>
                    )}
                </div>
                {isMobile && (
                    <div className="d-flex justify-content-between teammember-mobile">
                        <div>
                            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle caret>Select Team Member</DropdownToggle>
                                <DropdownMenu>
                                    {members.map(member => (
                                        <DropdownItem key={member.id} href={`/team/${member.id}`}>
                                            {member.name}
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        {hasAlt && (
                            <div>
                                <div className="SwitchContainer">
                                    <div
                                        className={
                                            activeOption === 'English'
                                                ? 'SwitchToggleItem SwitchActive'
                                                : 'SwitchToggleItem'
                                        }
                                        onClick={() => handleSwitchClick('English')}
                                    >
                                        <div className={'SwitchText'}>English</div>
                                    </div>
                                    <div
                                        className={
                                            activeOption !== 'English'
                                                ? 'SwitchToggleItem SwitchActive'
                                                : 'SwitchToggleItem'
                                        }
                                        onClick={() => handleSwitchClick(alt_lng)}
                                    >
                                        <div className={'SwitchText'}>{alt_lng}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!hasAlt && <div />}
                    </div>
                )}
            </section>
        </>
    );
};
